import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import { getHistorial } from '../services/posnetsChoferesService';

const headerCellSx = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.78rem',
  textTransform: 'uppercase',
  bgcolor: 'grey.50',
};

const ModalHistorial = ({ open, chofer, onClose }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open || !chofer) return;

    let cancelado = false;
    setLoading(true);
    setError('');
    setRows([]);

    getHistorial(chofer.id)
      .then((data) => {
        if (!cancelado) setRows(Array.isArray(data) ? data : []);
      })
      .catch((err) => {
        if (!cancelado) setError(err.message || 'Error al obtener el historial');
      })
      .finally(() => {
        if (!cancelado) setLoading(false);
      });

    return () => {
      cancelado = true;
    };
  }, [open, chofer]);

  const detalle = (row) => {
    if (row.posnet_nuevo && row.chofer_anterior_del_posnet) {
      return `Traspasada desde ${row.chofer_anterior_del_posnet}`;
    }
    if (row.posnet_nuevo) return row.posnet_anterior ? 'Cambio' : 'Asignación';
    return 'Quitada';
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <HistoryIcon fontSize="small" />
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Historial de posnet - {chofer?.nombre_apellido}
          </Typography>
        </Box>
        <IconButton size="small" onClick={onClose} sx={{ color: 'inherit' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress size={32} />
          </Box>
        ) : (
          !error && (
            <TableContainer sx={{ mt: 2 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={headerCellSx}>Fecha</TableCell>
                    <TableCell sx={headerCellSx}>Movimiento</TableCell>
                    <TableCell sx={headerCellSx}>Posnet anterior</TableCell>
                    <TableCell sx={headerCellSx}>Posnet nuevo</TableCell>
                    <TableCell sx={headerCellSx}>Usuario</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={5} align="center" sx={{ py: 4, color: 'text.secondary' }}>
                        Sin movimientos registrados
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell sx={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>
                          {moment(row.fecha).format('DD/MM/YYYY HH:mm')}
                        </TableCell>
                        <TableCell sx={{ fontSize: '0.82rem' }}>{detalle(row)}</TableCell>
                        <TableCell sx={{ fontSize: '0.82rem', wordBreak: 'break-all' }}>{row.posnet_anterior || '-'}</TableCell>
                        <TableCell sx={{ fontSize: '0.82rem', wordBreak: 'break-all' }}>{row.posnet_nuevo || '-'}</TableCell>
                        <TableCell sx={{ fontSize: '0.82rem' }}>{row.usuario}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ModalHistorial;
